import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type TaskContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, status: Types.ResourceStatusEnum, instruction?: { text?: string | null } | null, cover?: { mediaId: string, url?: string | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null } | null };


export type TaskContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TaskContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, status: Types.ResourceStatusEnum, instruction?: { text?: string | null } | null, cover?: { mediaId: string, url?: string | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type TaskContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const TaskContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment TaskContentCard on TaskContentType {
  id
  name
  type
  duration
  status
  instruction {
    text
  }
  cover {
    mediaId
    url
  }
  performance {
    id
    status
    estimatedTimeSpent
  }
}
    `;
export const TaskContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment TaskContentCardWithUserPerformance on TaskContentType {
  id
  name
  type
  duration
  status
  instruction {
    text
  }
  cover {
    mediaId
    url
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;